  <div class="modal-header p-3">
      <span data-dismiss="modal" aria-label="Close" class="cursor-pointer mr-2">
            <img class="float-right" src="assets/themes/icons/cancel.svg" alt="cross" (click)="fcs.closeWebModal()" />
      </span>
  </div>
  <div class="prod-tnc-modal text-left p-3 link-text">
    <p class="pl-3" innerHTML="{{ tncContent }}"></p>
  </div>